import $ from './framework/$'
import serialize from './plugins/serialize'

/* -----------------------------------------------------------------------------
    ON RUN - Preload and Page Init
------------------------------------------------------------------------------*/

const nav = document.getElementById('js-nav');
const catNav = document.getElementById('js-cat-menu');

window.addEventListener('load', function() {
    const btnMenu = document.getElementById('js-btnMenu');
    // const style = document.createElement('style');
    // style.innerHTML = '.is-open{height:auto;}'
    
    // document.head.appendChild(style);

    // css(nav, {overflow:'hidden'});
    btnMenu.addEventListener('click', function(){
        toggleMenu();
    });

});

window.addEventListener('resize', function() {
    if(window.innerWidth > 639 && (nav.classList.contains('is-open') || nav.style.display === 'none')) {
        catNav.removeAttribute("style")
        nav.removeAttribute("style")
        nav.classList.remove('is-open');
    }
})

/* -----------------------------------------------------------------------------
    HANDLERS - Microinteraction
------------------------------------------------------------------------------*/

function toggleMenu() {
    nav.classList.toggle('is-open');
    
    if(nav.classList.contains('is-open')) {
        nav.style.height = 'auto'
        nav.style.display = 'flex'

        catNav.style.display = 'inline-block'
        catNav.style.height = 'auto'
    } else {
        nav.style.height = ''
        nav.style.display = 'none'

        catNav.style.display = 'none'
        catNav.style.height = ''
    }
}

function css(el, styles) {
    for (var property in styles)
        el.style[property] = styles[property];
}

/* -----------------------------------------------------------------------------
    Main
------------------------------------------------------------------------------*/

/* Maintaining single file, for now! */

initializeAll()

function initializeAll() {

    /* -----------------------------------------------------------------------------
        Encourage user to subscribe!
    ------------------------------------------------------------------------------*/

    $(':ad-toggle-off').on('click', (e, el) => {

        if (!$(el).hasClass('active')) {
            
            $(':ad-toggle-on').removeClass('active')
            $(el).addClass('active')

            setTimeout(function(){ 
                window.location = "/subscribe";
            }, 1000);

        }
    })

    /* -----------------------------------------------------------------------------
        Remove all success message!
    ------------------------------------------------------------------------------*/

    $(':show-password').on('click', (e, el) => {

        if (!$(el).hasClass('active')) {
            
            $(':password-field')[0].setAttribute('type', 'text')
            $(el).addClass('active')
            $(el).text('Hide Password')

        }else{

            $(':password-field')[0].setAttribute('type', 'password')
            $(el).removeClass('active')
            $(el).text('Show Password')

        }
    })

    /* -----------------------------------------------------------------------------
        Remove all success message!
    ------------------------------------------------------------------------------*/
    
    setTimeout(function(){ 
        $(':request-msg').hide()
    }, 2500);


    /* -----------------------------------------------------------------------------
        Edit Account / Password Update
    ------------------------------------------------------------------------------*/

    $(':editAccount').on('submit', (e, el) => passwordUpdate(e, $(el)))

    function passwordUpdate(e, el) {
        e.preventDefault()

        if (! passwordUpdateValidate(el[0])) {
            e.preventDefault()            
            return;
        }

        el[0].submit()
    }
    
    function passwordUpdateValidate(form) {

        let jsFormErrors = document.querySelector('[data-ref="js-form-errors"]')
            jsFormErrors.innerHTML = ''

        let currentPassword = document.querySelector('[data-ref="currentPassword"]').value
        let newPassword = document.querySelector('[data-ref="newPassword"]').value
        let confirmPassword = document.querySelector('[data-ref="confirmPassword"]').value

        if( currentPassword != '' || newPassword != '' ){

            if( newPassword.length == 0 ){
                jsFormErrors.innerHTML = 'Enter your New Password'                
                return false
            }

            if( newPassword.length <= 5 ){
                jsFormErrors.innerHTML = 'New Password too short'                
                return false
            }
            
            if( newPassword != confirmPassword ){
                jsFormErrors.innerHTML = 'New Password does not match'
                return false
            }
        
        }

        return true
    }

}




//////////////////
// WEBPACK FOOTER
// ./src/js/main.js
// module id = 2
// module chunks = 0